import { render, staticRenderFns } from "./correctDialog.vue?vue&type=template&id=3b9174d3&scoped=true&"
import script from "./correctDialog.vue?vue&type=script&lang=js&"
export * from "./correctDialog.vue?vue&type=script&lang=js&"
import style0 from "./correctDialog.vue?vue&type=style&index=0&id=3b9174d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9174d3",
  null
  
)

export default component.exports